// dependencies
import { useQuery } from "@tanstack/react-query";

// api
import { getUserDirectReports } from "../../services/defs/direct-reports";

export const useDirectReports = (userID: string, includeDeactivated = false) => {
	const query = useQuery({
		queryKey: ["direct-reports", userID, includeDeactivated],
		queryFn: () => getUserDirectReports(userID, includeDeactivated),
		refetchOnWindowFocus: false,
		meta: {
			errorMessage: "Error getting direct reports",
		},
	});

	return query;
};
